import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  FormHelperText,
  MenuItem,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import { ErrorMessage, Form, Formik } from "formik";
import React, { useState } from "react";
import Images from "../../assets";
import { useAppDispatch, useAppSelector } from "../../assets/hooks";
import Socket from "../../assets/socket";
import {
  getAlllistings,
  getSearchUniversityDetails,
  recommedUniversity,
} from "../../services";
import { closePopup } from "../../store/slices/popupSlice";
import { addRecommended } from "../../store/slices/recommendations";
import { Course, Event } from "../../types/types";
import { Close } from "@mui/icons-material";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";

interface University {
  _id: string;
  name: string;
  logoSrc: string;
  community: string;
  courses: any;
}
const Recommendation = (props: any) => {
  const dispatch = useAppDispatch();
  const profile = useAppSelector((state) => state.profileInfo);

  const [options, setOptions] = useState<University[]>([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [univerId, setUniverId] = useState("");
  const [courses, setCourses] = useState<Course[]>([]);
  const [loading, setLoading] = useState(false);
  const [coursesLoading, setCoursesLoading] = useState(false);
  const [submiting, setSubmiting] = useState(false);
  const [showCustomInput, setShowCustomInput] = useState(false);

  const initialValues = {
    studentId: props.data,
    universityId: univerId,
    courseId: "",
    possibilityOfAdmit: "",
  };

  const getUniversity = async (searchTerm: string) => {
    setLoading(true);
    const response = await getSearchUniversityDetails(searchTerm,1, 8,0,1,0,0,0);
    if (response) {
      setOptions(response.data.universities);
      // console.log(response.data.universities)
    } else {
      // setError(response.data.message);
    }
    setLoading(false);
  };
console.log(options,"options")
  const eventHandler = async (event: Event) => {
    switch (event.name) {
      case "inputChange":
        const inputValue = event.data.target.value ?? "";
        setSelectedOption(inputValue);
        // User is editing free-text; reset selected university/course bindings.
        setUniverId("");
        setCourses([]);

        const query = inputValue.trim();
        const regex = /^[A-Za-z0-9\s]+$/;
        if (query !== "" && regex.test(query)) {
          getUniversity(query);
          setShowCustomInput(true);
        } else {
          setOptions([]);
          setShowCustomInput(false);
        }
        break;
      case "optionChange":
        if (!event.data) {
          setSelectedOption("");
          setUniverId("");
          setCourses([]);
          setOptions([]);
          setShowCustomInput(false);
          break;
        }
        setSelectedOption(event.data.name ?? "");
        setUniverId(event.data?._id);
        setShowCustomInput(false)
        if (event.data?._id) {
          setCoursesLoading(true);
          try {
            const response = await getAlllistings("courses", {
              currentPage: 1,
              filterData: [{ type: "universityId", data: [event.data?._id] }],
            });
            if (response) {
              setCourses(response?.data?.list ?? []);
            } else {
              setCourses([]);
            }
          } catch (error) {
            setCourses([]);
          } finally {
            setCoursesLoading(false);
          }
        }

        break;
    }
  };

  const submit = async (values: any) => {
    setSubmiting(true);
    values.universityId = univerId;
    values.studentId = props.data;
    const response = await recommedUniversity(values);
    if (response) {
      dispatch(addRecommended(response.data.data));
      setSubmiting(false);
      dispatch(closePopup())
      const triggerObject = {
        action: "recommendationsUpdated",
        sender: profile.data,
        recievers: [{ _id: props.data }],
        data: [response.data.data],
        // data:{message:response.data.data?.message,roomid:chatData._id}
      };
      // console.log("trigger", triggerObject);
      Socket.emit("trigger", triggerObject);
    }
  };
  
  return (
    <div>
      <Formik
        initialValues={initialValues}
        // validationSchema={profileSchema}
        onSubmit={(values: any) => submit(values)}
      >
        {({ touched, errors, values, handleChange, setFieldValue }) => {
          const canSubmit =
            !!univerId &&
            !!values.courseId &&
            !!values.possibilityOfAdmit &&
            !coursesLoading &&
            !submiting;
          return (
            <Form className="mt-5">
              {/* <Autocomplete
                // name="universityId"
                options={options}
                onInputChange={(event, newValue) =>
                  eventHandler({ name: "inputChange", data: newValue })
                }
                getOptionLabel={(option) => option?.name}
                onChange={(event, newValue) =>
                  eventHandler({ name: "optionChange", data: newValue })
                }
                defaultValue={selectedOption}
                loading={loading}
                fullWidth
                size="small"
                // required
                sx={{
                  // mb: 2,
                  "& .MuiAutocomplete-listbox": {
                    maxHeight: "22vh !important",
                    height: "22vh !important",
                  },
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="University"
                    variant="outlined"
                    sx={{
                      mb: 2,
                      "& .MuiAutocomplete-listbox": {
                        // maxHeight: "22vh !important",
                        height: "22vh !important",
                      },
                    }}
                  />
                )}
              /> */}
              <Box sx={{ mb: 1.5 }}>
                <Typography
                  variant="caption"
                  sx={{
                    color: "#3B3F76",
                    fontWeight: 600,
                    letterSpacing: 0.2,
                    display: "block",
                    mb: 0.5,
                  }}
                >
                  Step 1 of 2 - Choose university
                </Typography>
              </Box>
              <Box sx={{ width: "100%", position: "relative",mb:2 }}>
              <TextField
                        value={selectedOption}
                        onChange={(event) =>
                          eventHandler({ name: "inputChange", data: event })
                        }
                        placeholder="Enter your institution name"
                        variant="outlined"
                        name="underGraduation.instituteName"
                        size="small"
                        autoComplete="off"
                        fullWidth
                        sx={{
                          mt: 0.2,
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "12px",
                            background: "#FCFCFF",
                            "& fieldset": { borderColor: "#D8DEF2" },
                            "&:hover fieldset": { borderColor: "#AEB8E8" },
                            "&.Mui-focused fieldset": { borderColor: "#4B54A6" },
                          },
                        }}
                        InputProps={{
                          endAdornment: (
                            <>
                              {loading && <CircularProgress color="inherit" size={20} />}
                              {selectedOption && (
                                <Close
                                  sx={{ cursor: "pointer" }}
                                  onClick={() => {
                                    setSelectedOption("");
                                    setUniverId("");
                                    setCourses([]);
                                    setOptions([]);
                                    setShowCustomInput(false);
                                  }}
                                />
                              )}
                            </>
                          ),
                        }}
                      />
                      {showCustomInput && options.length > 0 && (
                      <Box
                        sx={{
                          position: "absolute",
                          zIndex: "1000",
                          backgroundColor: "#fff",
                          boxShadow: 1,
                          maxHeight: "200px",
                          overflowY: "auto",
                          width: "100%",
                        }}
                      >
                        {options.map((option: any, index:number) => (
                          <MenuItem
                            key={index}
                            sx={{
                              fontSize: "14px !important",
                              display: "flex",
                              alignItems: "center",
                              whiteSpace: "normal",
                            }}
                            onClick={(event) =>
                              eventHandler({ name: "optionChange", data: option })
                            }
                          >
                           {option.name}
                          </MenuItem>
                        ))}
                      </Box>
                    )}
                    </Box>
                    {coursesLoading && (
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          mb: 1.5,
                          mt: -0.75,
                          px: 1.25,
                          py: 0.85,
                          borderRadius: 2,
                          background:
                            "linear-gradient(135deg, rgba(238,243,255,1) 0%, rgba(247,249,255,1) 100%)",
                          border: "1px solid #DCE4FF",
                        }}
                      >
                        <CircularProgress size={15} sx={{ color: "#3B3F76" }} />
                        <Typography fontSize="13px" color="text.secondary">
                          Finding programs at {selectedOption || "selected university"}...
                        </Typography>
                      </Box>
                    )}
              <Box sx={{ mb: 1.2 }}>
                <Typography
                  variant="caption"
                  sx={{
                    color: "#3B3F76",
                    fontWeight: 600,
                    letterSpacing: 0.2,
                    display: "block",
                    mb: 0.5,
                  }}
                >
                  Step 2 of 2 - Course and admit chance
                </Typography>
              </Box>
              <FormControl fullWidth sx={{ mb: 2 }}>
                <Typography
                  sx={{ mb: 0.8, color: "#59628E", fontSize: "0.9rem", fontWeight: 600 }}
                >
                  Courses
                </Typography>
                <Box
                  sx={{
                    border: "1px solid #D8DEF2",
                    borderRadius: "12px",
                    background: "#FCFCFF",
                    minHeight: 64,
                    maxHeight: 220,
                    overflowY: "auto",
                    p: 1,
                  }}
                >
                  {!univerId ? (
                    <Typography color="text.secondary" fontSize="0.9rem" sx={{ p: 1 }}>
                      Select university first
                    </Typography>
                  ) : coursesLoading ? (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, p: 1 }}>
                      <CircularProgress size={16} />
                      <Typography fontSize="13px">Loading courses...</Typography>
                    </Box>
                  ) : courses.length === 0 ? (
                    <Typography color="text.secondary" fontSize="0.9rem" sx={{ p: 1 }}>
                      No courses found
                    </Typography>
                  ) : (
                    courses.map((item, i) => {
                      const selected =
                        String(values.courseId ?? "") === String(item?._id ?? "");
                      return (
                        <Box
                          key={i}
                          onClick={() => setFieldValue("courseId", item._id)}
                          role="button"
                          tabIndex={0}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                              e.preventDefault();
                              setFieldValue("courseId", item._id);
                            }
                          }}
                          sx={{
                            p: 1.1,
                            mb: 0.8,
                            borderRadius: "10px",
                            cursor: "pointer",
                            border: selected ? "2px solid #4B54A6" : "1px solid #E4E8F7",
                            background: selected
                              ? "linear-gradient(135deg, #EEF1FF 0%, #E6EBFF 100%)"
                              : "#fff",
                            boxShadow: selected
                              ? "0 6px 14px rgba(75, 84, 166, 0.18)"
                              : "none",
                            transition: "all 0.15s ease",
                            "&:hover": { borderColor: "#B7C0EB", background: "#F7F8FE" },
                            "&:focus-visible": {
                              outline: "2px solid #7F8DE8",
                              outlineOffset: "2px",
                            },
                          }}
                        >
                          <Box sx={{ display: "flex", justifyContent: "space-between", gap: 1 }}>
                            <Box sx={{ minWidth: 0 }}>
                              <Typography fontSize="14px" fontWeight="600" color="#2F356F">
                                {item.name}
                              </Typography>
                              <Typography fontSize="12px" fontWeight="400" color="#6A7195">
                                {item?.studyLevel},{item.subDiscipline}
                              </Typography>
                            </Box>
                            {selected ? (
                              <CheckCircleRoundedIcon sx={{ color: "#4B54A6", fontSize: 20 }} />
                            ) : null}
                          </Box>
                        </Box>
                      );
                    })
                  )}
                </Box>
                {!coursesLoading && univerId && courses.length === 0 ? (
                  <FormHelperText>No courses found for this university.</FormHelperText>
                ) : null}
              </FormControl>

              <FormControl fullWidth sx={{ mb: 2 }}>
                <Typography
                  sx={{ mb: 0.8, color: "#59628E", fontSize: "0.9rem", fontWeight: 600 }}
                >
                  Possibility of admit
                </Typography>
                <ToggleButtonGroup
                  exclusive
                  value={values.possibilityOfAdmit}
                  onChange={(_, val) => {
                    if (val) setFieldValue("possibilityOfAdmit", val);
                  }}
                  sx={{
                    width: "100%",
                    display: "grid",
                    gridTemplateColumns: "repeat(3, 1fr)",
                    gap: 1,
                    "& .MuiToggleButtonGroup-grouped": {
                      border: "1px solid #D9DEEF !important",
                      borderRadius: "10px !important",
                      textTransform: "none",
                      fontWeight: 600,
                      color: "#3B3F76",
                      background: "#FAFBFF",
                      transition: "all 0.2s ease",
                      "&:hover": {
                        background: "#ECEFFF",
                        borderColor: "#C7CFF4 !important",
                      },
                    },
                    "& .Mui-selected": {
                      background: "linear-gradient(135deg, #4B54A6 0%, #353D83 100%) !important",
                      color: "#fff !important",
                      borderColor: "#353D83 !important",
                      boxShadow: "0 4px 14px rgba(53, 61, 131, 0.28)",
                    },
                  }}
                >
                  {["Safe", "Moderate", "Ambitious"].map((item) => (
                    <ToggleButton key={item} value={item}>
                      {item}
                    </ToggleButton>
                  ))}
                </ToggleButtonGroup>
              </FormControl>
              <ErrorMessage name="possibilityOfAdmit" component="div" />
              <Box sx={{ mt: 2.5, display: "flex", justifyContent: "center" }}>
                <Button
                  type="submit"
                  disabled={!canSubmit}
                  sx={{
                    background: canSubmit
                      ? "linear-gradient(135deg, #4B54A6 0%, #353D83 100%)"
                      : "#D8DDF1",
                    color: canSubmit ? "#fff" : "#7A83A7",
                    fontWeight: "700",
                    fontSize: "15px",
                    minWidth: "185px",
                    minHeight: "48px",
                    letterSpacing: "0.25px",
                    textTransform: "none",
                    borderRadius: "14px",
                    transition: "all 0.2s ease",
                    boxShadow: canSubmit
                      ? "0 10px 22px rgba(53, 61, 131, 0.32)"
                      : "none",
                    "&:hover": {
                      background: canSubmit
                        ? "linear-gradient(135deg, #434C9B 0%, #2E3573 100%)"
                        : "#D8DDF1",
                      color: canSubmit ? "#fff" : "#6C7398",
                      boxShadow: canSubmit
                        ? "0 12px 24px rgba(46, 53, 115, 0.36)"
                        : "none",
                      transform: canSubmit ? "translateY(-1px)" : "none",
                    },
                  }}
                >
                  {submiting ? (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <CircularProgress size={16} sx={{ color: "#fff" }} />
                      Recommending...
                    </Box>
                  ) : (
                    "Recommend Course"
                  )}
                </Button>
              </Box>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default Recommendation;
